function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Slide, ToastContainer } from "react-toastify";

class ConfigToast extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(ToastContainer, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: true,
        newestOnTop: true,
        closeOnClick: true,
        rtl: false,
        pauseOnVisibilityChange: true,
        draggable: true,
        pauseOnHover: true,
        transition: Slide
      });
    });
  }

}

export default ConfigToast;